import { createAsyncThunk } from '@reduxjs/toolkit';

import { ThunkApiConfigType } from '../../../../main/store/main.store.ts';
import { getSentryUtil } from '../../../../main/utils/monitoring/sentry.util.ts';
import { getTrackerUtil } from '../../../../main/utils/trackers/tracker.util.ts';

import { AUTH_SLICE_NAME } from '../auth.slice.types.ts';

interface Props {
  email: string;
  userId: string;
  preferredName?: string;
}

export const identifyUserTrackersThunk = createAsyncThunk<void, Props, ThunkApiConfigType>(
  `${AUTH_SLICE_NAME}/identifyUserTrackers`,
  ({ email, userId, preferredName }, _) => {
    getTrackerUtil().identify(userId);
    getSentryUtil().setUser(userId, email);

    getTrackerUtil().setUserProperties({
      $email: email,
      $name: preferredName,
    });
  }
);
